import React from 'react'
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md'
import PropTypes from 'prop-types'
import { useVideoModalState } from '../../../../components/shared/VideoModal/VideoModal.hook'
import VideoModal from './../../VideoModal/VideoModal'
import styled from 'styled-components/macro'
import { media } from '../../../../ui/rwd'
import {
  Slider,
  PrevSlide,
  NextSlide,
  SlideItemPlay,
  SlideItemImage
} from './ProductImageSliderStyledComponents'
import { isVideo } from './../../../../helpers/isVideo'
import { generateVideoThumbnail } from './../../../../helpers/generateVideoThumbnail'

const NextArrow = React.memo(({ onClick }) => (
  <NextSlide onClick={onClick} type='button' data-role='none'>
    <MdKeyboardArrowRight />
  </NextSlide>
))
NextArrow.displayName = 'NextArrow'
const PrevArrow = React.memo(({ onClick }) => (
  <PrevSlide onClick={onClick} type='button' data-role='none'>
    <MdKeyboardArrowLeft />
  </PrevSlide>
))
PrevArrow.displayName = 'PrevArrow'

NextArrow.propTypes = PrevArrow.propTypes = {
  onClick: PropTypes.func
}

// HAVE TO BE IN THIS FILE BECAUSE OF WEIRD BUG

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />
}
const Slide = styled.div`
  position: relative;
  cursor: pointer;
  width: 100% !important;
  display: block !important;
  height: auto;
  flex: 1;
  ${media.md`
    height: 400px;
  `}
`

const ProductImageSlider = ({
  images,
  slide: SlideItem = Slide,
  productName,
  ...rest
}) => {
  const { open, video, handleChange } = useVideoModalState()
  const closeModal = () => handleChange({ open: false, video: undefined })
  return [
    <Slider key='slider' {...sliderSettings} {...rest}>
      {images.map(item => {
        const videoCheck = isVideo(item)
        return (
          <SlideItem
            key={item}
            onClick={() => {
              videoCheck && handleChange({ open: true, video: item })
            }}
          >
            <SlideItemImage
              src={videoCheck ? generateVideoThumbnail(item) : item}
              width='100%'
              height='100%'
            />
            {videoCheck && <SlideItemPlay />}
          </SlideItem>
        )
      })}
    </Slider>,
    video ? (
      <VideoModal
        name={productName}
        toggle={closeModal}
        open={open}
        video={video}
      />
    ) : null
  ]
}

ProductImageSlider.propTypes = {
  images: PropTypes.array.isRequired,
  productName: PropTypes.string
}
export default ProductImageSlider
export { Slide, NextArrow, PrevArrow }
